import React, { Component } from 'react'
import PropTypes from 'prop-types';
import JobIndustries from './JobIndustries';
import JobLocations from './JobLocations';
import Anchor from "../../../../../dashboardNew/objects/Anchor";
import { format } from '../../../../../../helpers/common/date';
import { dateHelpers } from '../../../../../../helpers';

class JobOverview extends Component {
    constructor( props ){
        super( props );
        this.state = {
            url : this.props.job.application_url && this.props.job.application_url != null ? this.props.job.application_url : undefined
        };
    };

    isExpired = () => +(new Date( format( this.props.job.end_date, 'default' ) )) < +(new Date( format( new Date(), 'default' ) ));

    setFavourite = () => {
        if( !this.props.job.favourite ){
            this.props.addJobToFavourites( localStorage.getItem( 'person_id' ), this.props.job.id, null, true );
            return;
        };

        this.props.removeJobFromFavourites( localStorage.getItem( 'person_id' ), this.props.job.id, null, true );
    };

    favourite = () => {
        if( this.props.job.favourite ){
            return (
                <div className="row">
                    <div className="col-12 job-favourite">
                        <button className={`theme-favourite added alt${ this.isExpired() ? " disabled" : "" }`} onClick={ () => this.setFavourite() }>
                            Remove from Favourites
                            <i className="fa fa-heart fav-icon"/>
                        </button>
                    </div>
                </div>
            );
        };
        return (
            <div className="row">
                <div className="col-12 job-favourite">
                    <button className={`theme-favourite alt${ this.isExpired() ? " disabled" : "" }`} onClick={ () => this.setFavourite() }>
                        Add to Favourites
                        <i className="fa fa-heart fav-icon"/>
                    </button>
                </div>
            </div>
        );
    };

    cta = () => {
        if( this.state.url ){
            return (
                <button className={`theme-button${ this.isExpired() ? " disabled" : "" }`} onClick={ () => this.props.openInNewWindow( this.state.url ) }>
                    Apply
                </button>
            );
        };
        return (
            <Anchor path={`/jobs/${ this.props.job.id }/apply`} anchorClass={`theme-button${ this.isExpired() ? " disabled" : "" }`} internal>
                Apply
            </Anchor>
        );
    };

    logo = () => {
        if( this.props.job && this.props.job.company && this.props.job.company.logo ){
            return (
                <div className="col-12 logo-hold">
                    <img className="logo-company-job-overview" src={ this.props.job.company.logo } alt="" />
                </div>
            );
        };
    };

    render(){
        if( !this.props.job || !Object.keys( this.props.job ).length ){ return 'loading' };

        return (
            <article className="job-overview">
                <div className="row">
                    { this.logo() }
                </div>
                <div className="row">
                    <div className="col-xs-12 job-details-company-name">
                        <p><b>Company:</b> {( this.props.job && this.props.job.company && this.props.job.company.name ) || "N/A"}</p>
                    </div>
                    <div className="col-xs-12">
                        <JobIndustries job={ this.props.job } />
                    </div>
                    <div className="col-xs-12 job-details-sector-name">
                        <p><b>Sector:</b> { this.props.job.sector ? this.props.job.sector.name : "N/A" }</p>
                    </div>
                    <div className="col-xs-12">
                        <JobLocations job={ this.props.job } />
                    </div>
                </div>
                <div className="row job-details-box">
                    <div className="col-xs-12 job-details">
                        <p><strong>Salary:</strong> <span dangerouslySetInnerHTML={{ __html: this.props.job.salary }} /></p>
                        <p><b>Reference:</b> { this.props.job.id !== null ? this.props.job.id : "N/A" }</p>
                        {/* <p><b>Published Date:</b> { format( this.props.job.start_date, 'gbShortDatePadded' ) }</p> */}
                        {/* <p><b>End Date:</b> { this.props.job.end_date !== null ? format( this.props.job.end_date, 'gbShortDatePadded' ) : 'Not specified' }</p> */}
                        <p><b>Published Date:</b> { dateHelpers.dateConverter( this.props.job.start_date ) }</p>
                        <p><b>End Date:</b> { this.props.job.end_date !== null ? dateHelpers.dateConverter( this.props.job.end_date ) : 'Not specified' }</p>
                    </div>
                    <div className="col-xs-12 job-apply-button">
                        { this.cta() }
                        { this.favourite() }
                    </div>
                </div>
            </article>
        );
    }
};

JobOverview.propTypes = {
    addJobToFavourites      : PropTypes.func,
    removeJobFromFavourites : PropTypes.func,
    openInNewWindow         : PropTypes.func,
    job                     : PropTypes.object
};

export default JobOverview;



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobOverview.js